export default __webpack_public_path__ + "static/stove-6275fbe399472943b4a3b57e955d01ca.png";